import React from "react";
import { Search, Table } from "lucide-react";
import { LAYER } from "../pipeline/Layer";
import { formatNumber, cn } from "../../lib/utils";

export const KIND = { actual: ["Real 1Rotary", "text-success"], sample: ["Sample", "text-info"], promoted: ["Promoted", "text-success"],
  bronze: ["Raw Bronze", "text-warning"], empty: ["No rows yet", "text-muted"] };
export const kindOf = (t) => (t.kind === "actual" && t.practice ? ["Practice files", "text-warning"] : KIND[t.kind] || ["Preparing…", "text-muted"]);

// Left rail of the Explorer: search, layer filter and every Bronze / Silver / Gold table grouped by layer.
export default function CatalogRail({ entries, q, onQ, layer, onLayer, selected, onSelect }) {
  const shown = entries.filter(t => (layer === "all" || t.layer === layer) && (!q.trim() || t.search.includes(q.trim().toLowerCase())));
  return (
    <div className="space-y-3">
      <div className="tile p-3 flex items-center gap-2" data-testid="explorer-search">
        <Search size={14} className="text-muted" />
        <input data-testid="explorer-search-input" value={q} onChange={e => onQ(e.target.value)} placeholder="Search tables, columns, descriptions…"
               className="flex-1 bg-transparent outline-none text-sm placeholder:text-subtle" />
      </div>
      <div className="tile p-3 flex flex-wrap gap-2">
        {["all", "Gold", "Silver", "Bronze"].map(l => (
          <button key={l} onClick={() => onLayer(l)} data-testid={`layer-${l}`}
                  className={cn("text-[10px] uppercase tracking-widest font-semibold px-3 h-7 border rounded-sm transition-colors inline-flex items-center gap-1.5",
                    layer === l ? "bg-primary text-primary-fg border-primary" : "bg-surface-2 border-border hover:bg-surface")}>
            {l !== "all" && <span className={cn("w-1.5 h-1.5 rounded-full", LAYER[l].dot)} />}{l === "all" ? "All Layers" : l}
          </button>))}
      </div>
      <div className="tile" data-testid="table-list">
        <div className="px-4 py-3 border-b border-border text-[11px] font-semibold tracking-widest uppercase text-muted">Tables ({shown.length})</div>
        <div className="space-y-1 max-h-[640px] overflow-y-auto p-2">
          {["Gold", "Silver", "Bronze"].map(l => {
            const list = shown.filter(t => t.layer === l);
            if (!list.length) return null;
            return (
              <div key={l}>
                <div className={cn("text-[9px] uppercase tracking-[0.2em] font-bold px-2 py-1.5", LAYER[l].text)}>{l}</div>
                {list.map(t => {
                  const on = selected === t.name;
                  const [k, tone] = kindOf(t);
                  return (
                    <button key={t.name} onClick={() => onSelect(t.name)} data-testid={`table-row-${t.name}`}
                            className={cn("w-full text-left px-2.5 py-2 rounded-sm transition-colors flex items-center gap-2 border-l-2", on ? "bg-primary/10 border-l-primary" : "hover:bg-surface-2 border-transparent")}>
                      <Table size={11} className={cn("shrink-0", on ? "text-primary" : "text-muted")} />
                      <div className="flex-1 min-w-0">
                        <div className={cn("text-[12px] font-mono-tabular truncate", on && "text-primary font-semibold")}>{t.display}</div>
                        <div className="text-[9.5px] text-muted"><span className={tone}>{k}</span> · {formatNumber(t.rows_held || 0, { compact: true })} rows</div>
                      </div>
                    </button>);
                })}
              </div>);
          })}
          {!shown.length && <div className="px-2 py-6 text-center text-[12px] text-muted" data-testid="explorer-empty">No tables match.</div>}
        </div>
      </div>
    </div>
  );
}
